import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

// Demo mode when environment variables aren't set
const isDemoMode = true; // Always use demo mode for now since we don't have Supabase credentials

// Mock data for demo mode
const DEMO_POSTS = [{
  id: '1',
  slug: '50-dollar-challenge',
  title: 'The $50 Challenge: How Pocket Change Can Buy You a House',
  content: `# The $50 Challenge: How Pocket Change Can Buy You a House (No, Really!)

Ever looked at your spare change and thought, "What if this could buy me a house?" Well, grab your piggy bank and buckle up, because we're about to embark on a mind-bending journey that'll make you see those crumpled bills in a whole new light!...`,
  excerpt: 'Discover how saving just $50 a month can grow into a substantial house down payment...',
  cover_image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=1200&h=600&fit=crop',
  author_id: '1',
  category: 'Finance',
  tags: ['Investing', 'Real Estate', 'Personal Finance'],
  published: true,
  featured: true,
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  published_at: new Date().toISOString(),
  author: {
    name: 'Alex Chen',
    avatar_url: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=100&h=100&fit=crop'
  }
}];

// Mock Supabase client for demo mode
const mockClient = {
  from: (table: string) => ({
    select: (query?: string) => ({
      eq: (field: string, value: any) => ({
        single: () => Promise.resolve({ data: DEMO_POSTS[0], error: null }),
        order: () => Promise.resolve({ data: DEMO_POSTS, error: null })
      }),
      order: () => ({
        limit: () => Promise.resolve({ data: DEMO_POSTS, error: null })
      })
    })
  })
};

// Export the mock client
export const supabase = mockClient;

export const isDemoModeEnabled = () => isDemoMode;